// ResourceRows.tsx
import React from 'react';
import ResourceCard from './ResourceCard';
import { Resource } from '../common/types';
import { useAppSelector } from '../redux/hooks';
import { createRef, RefObject } from 'react';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import ScrollContainer from 'react-indiana-drag-scroll'

interface ResourceRowsProps {
    resources: Resource[];
    onResourceClick: (resource: Resource) => void;
}

const ResourceRows: React.FC<ResourceRowsProps> = ({ resources, onResourceClick, }) => {
    const searchTerm = useAppSelector((state) => state.search.terms["resourcesSearch"]);
    const categories = Array.from(new Set(resources.map(resource => resource.tag)));
    const scrollRefs: RefObject<HTMLDivElement>[] = categories.map(() => createRef<HTMLDivElement>());

    const scrollLeft = (index: number) => {
        const currentRef = scrollRefs[index].current;
        if (currentRef) {
            currentRef.scrollLeft -= 1000;
        }
    };

    const scrollRight = (index: number) => {
        const currentRef = scrollRefs[index].current;
        if (currentRef) {
            currentRef.scrollLeft += 1000;
        }
    };

    return (
        <div className="flex flex-col select-none">
            {categories.map((category, index) => {
                const filteredResources = resources.filter(resource =>
                    resource.tag === category &&
                    ((!searchTerm) ||
                        (searchTerm && (
                            resource.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            resource.subtitle.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            resource.tag.toLowerCase().includes(searchTerm.toLowerCase())
                        )))
                );
                const showArrows = filteredResources.length >= 5;
                return (
                    <div key={index} className="mb-8 w-full">
                        <h2 className="mb-4 text-2xl font-semibold">{category}</h2>
                        <div className="relative w-full flex items-center">
                            {showArrows && (
                                <button
                                    onClick={() => scrollLeft(index)}
                                    className="absolute z-10 p-6 left-0 2xl:-left-8 transition duration-300 bg-white rounded-full opacity-50 hover:opacity-100 shadow-lg"
                                >
                                    <FaChevronLeft className="" />
                                </button>
                            )}
                            {showArrows && (
                                <button
                                    onClick={() => scrollRight(index)}
                                    className="absolute z-10 p-6 right-0 2xl:-right-8 transition duration-300 bg-white rounded-full opacity-50 hover:opacity-100 shadow-lg"
                                >
                                    <FaChevronRight className="" />
                                </button>
                            )}
                            <ScrollContainer innerRef={scrollRefs[index]} className="flex gap-4 overflow-x-auto no-scrollbar scroll-smooth">
                                {filteredResources.map(resource => (
                                    <div key={resource.id} onClick={() => onResourceClick(resource)}>
                                        <ResourceCard key={resource.id} {...resource} />
                                    </div>
                                ))}
                            </ScrollContainer>
                        </div>
                    </div>
                );
            }
            )}
        </div>
    );
}

export default ResourceRows;
